<template>
  <div>
    <template v-if="stacked">
      <v-autocomplete
        dense
        outlined
        label="Tipo de histórico"
        v-model="source"
        :items="sources"
        item-text="label"
        item-value="value"
        :disabled="disabled"
        @change="changeSource"
      >
      </v-autocomplete>
      <v-autocomplete
        v-if="source === 'operadora'"
        dense
        outlined
        label="Selecione a operadora"
        v-model="idOperadora"
        :items="operadoras"
        item-text="nome_operadora"
        item-value="id_operadora"
        :loading="loadingOperadoras"
        :disabled="disabled || loadingOperadoras"
        @change="emitChange"
      >
      </v-autocomplete>
    </template>
    <template v-else>
      <v-row dense>
        <v-col cols="3">
          <v-autocomplete
            dense
            outlined
            label="Tipo de histórico"
            v-model="source"
            :items="sources"
            item-text="label"
            item-value="value"
            :disabled="disabled"
            @change="changeSource"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="3" v-if="source === 'operadora'">
          <v-autocomplete
            dense
            outlined
            label="Selecione a operadora"
            v-model="idOperadora"
            :items="operadoras"
            item-text="nome_operadora"
            item-value="id_operadora"
            :loading="loadingOperadoras"
            :disabled="disabled || loadingOperadoras"
            @change="emitChange"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
    </template>
    <v-row dense v-if="$slots.default || $slots.package">
      <v-col cols="3" class="pt-0">
        <slot />
      </v-col>
      <v-col cols="3" class="pt-0" v-if="$slots.package">
        <slot name="package" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "@/axios.config";

export default {
  name: "HistoricoSourceSelector",
  props: {
    value: {
      type: Object,
      default: () => ({ historic_source: "join", id_operadora: null })
    },
    disabled: {
      type: Boolean,
      default: false
    },
    stacked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      source: this.value.historic_source || "join",
      idOperadora: this.value.id_operadora || null,
      operadoras: [],
      loadingOperadoras: false,
      sources: [
        { label: "Histórico Join", value: "join" },
        { label: "Histórico Operadora", value: "operadora" }
      ]
    };
  },
  async mounted() {
    if (this.source === "operadora") {
      await this.loadOperadoras();
    }
  },
  watch: {
    value: {
      deep: true,
      async handler(newValue) {
        this.source = newValue.historic_source || "join";
        this.idOperadora = newValue.id_operadora || null;
        if (this.source === "operadora" && this.operadoras.length === 0) {
          await this.loadOperadoras();
        }
      }
    }
  },
  computed: {
    isValid() {
      return this.source === "join" || !!this.idOperadora;
    }
  },
  methods: {
    async changeSource() {
      this.idOperadora = null;
      if (this.source === "operadora" && this.operadoras.length === 0) {
        await this.loadOperadoras();
      }
      this.emitChange();
    },
    async loadOperadoras() {
      this.loadingOperadoras = true;
      try {
        const { data } = await axios.get("/fields/provider");
        if (data.success === false) {
          throw new Error(data.message);
        }
        this.operadoras = data.data;
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.loadingOperadoras = false;
    },
    emitChange() {
      const payload = {
        historic_source: this.source,
        id_operadora: this.source === "operadora" ? this.idOperadora : null
      };
      this.$emit("input", payload);
      this.$emit("change", { ...payload, isValid: this.isValid });
    }
  }
};
</script>
